<template>
  <div>
    <NativeCreativePreview
      :advertiser="advertiser"
      :creative="creative"
      :form="form"
      :index="index"
      v-if="(
        form &&
        (
          form.format === 'NATIVE_DISPLAY' ||
          form.format === 'PUSH'
        )
      ) ||
      (
        creative && (
          creative.format === 'NATIVE_DISPLAY' ||
          creative.format === 'PUSH'
        )
      )"
    />
  </div>
</template>

<script>

import NativeCreativePreview from '@/v1/components/creatives/CreativePreview/NativeCreativePreview.vue'

export default {
  props: ['advertiser', 'creative', 'form', 'index'],
  name: 'CreativePreviewWrapper',
  components: {
    NativeCreativePreview
  }
}
</script>
